import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import api from '../utils/api';
import {
  defaultAdSenseConfig,
  ensureAdSenseScript,
  normalizeAdSenseClient,
} from '../utils/adsense';

const AdSenseContext = createContext(defaultAdSenseConfig);

export function AdSenseProvider({ children }) {
  const [config, setConfig] = useState(defaultAdSenseConfig);

  useEffect(() => {
    let cancelled = false;
    api
      .get('/settings/adsense')
      .then(({ data }) => {
        if (cancelled || !data) return;
        setConfig({
          enabled: data.enabled !== false,
          client: normalizeAdSenseClient(data.client),
          slots: { ...defaultAdSenseConfig.slots, ...(data.slots || {}) },
        });
      })
      .catch(() => {
        if (!cancelled) setConfig(defaultAdSenseConfig);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    if (!config.enabled || !config.client) return;
    ensureAdSenseScript(config.client);
  }, [config.enabled, config.client]);

  const value = useMemo(() => config, [config]);

  return <AdSenseContext.Provider value={value}>{children}</AdSenseContext.Provider>;
}

export function useAdSense() {
  return useContext(AdSenseContext);
}
